import Vue from 'vue'

const TableInstance = Vue.extend(require('./index.vue').default);
let instance = null
let tablePromise = null
let tableResolve = null

let getInstance = () => {
  return new TableInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
  if (tableResolve) {
    tableResolve(false)
    tableResolve = null
  }
  tablePromise = null
}

let Table = (msg) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  document.body.appendChild(instance.$el);
  tablePromise = new Promise((resolve, reject) => {
    tableResolve = resolve
  })
  instance.open(msg, tableResolve)

  return tablePromise
}

export default Table
